import type { DomainMapper } from '../types';

const se: DomainMapper = {
  countryCode: 'dk',
  currency: 'DKK',
  dataAreaId: 'se01',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/DK.svg',
  languagePrimary: true,
  locale: 'da',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-dk.xml',
  storyblokBasePath: 'dk',
  url: 'https://kahrs-preview.iveo.store/dk',
  algoliaIndex: 'b2b-dk-da-DK-products',
  algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1454,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1454,
    algoliaIndex: 'b2b-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2b-dk-da-DK-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-dk.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1476,
    algoliaIndex: 'b2c-dk-da-DK-products',
    algoliaIndexAutocomplete: 'b2c-dk-da-DK-productsquery_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-dk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default se;
